import React, { MouseEvent } from 'react';
import styled from 'styled-components';

import { showErrorToast } from '../../../utilities/notificationUtils';

import Button from '../../../components/Button/NewButton';
import BalanceExplainer from './BalanceExplainer';
import TermsDetails from '../../Book/components/TermsDetails';

import { centsToCurrency } from './util';

import { typography } from '../../../styled';
import { themes, Package } from 'kb-shared';
const { colors } = themes;
const {
  serif: {
    card: { H1 }
  }
} = typography;

interface ContainerProps {
  shouldDisplay: boolean;
}

const Container = styled.div`
  align-items: center;
  background-color: ${colors.KBNight};
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  opacity: ${({ shouldDisplay }: ContainerProps) => (shouldDisplay ? '1.0' : '0.0')};
  padding: 20px 24px 28px 24px;
  transition: opacity 400ms;
`;

const Price = styled(H1)`
  color: ${colors.KBWhite};
  margin: 20px;
`;

type Props = {
  shouldDisplay: boolean;
  cycle: Package;
  hasAgreedToTerms: boolean;
  isDeposit: boolean;
  loading: boolean;
  onAgreedToTerms: (e: MouseEvent<HTMLDivElement>) => void;
  onConfirmation: () => Promise<void>;
  discountCode?: string;
  rateCents: number;
};

const PackageAndTerms = (props: Props) => {
  const {
    cycle,
    rateCents,
    shouldDisplay,
    hasAgreedToTerms,
    onAgreedToTerms,
    onConfirmation,
    loading,
    isDeposit
  } = props;
  if (!cycle) return null;
  const { description, quantity } = cycle;
  return (
    <Container shouldDisplay={shouldDisplay}>
      <BalanceExplainer description={description} cycleCount={quantity} deposit={isDeposit} />
      <Price>{`$${centsToCurrency(rateCents)}${isDeposit ? ' deposit due today' : ''}`}</Price>

      <TermsDetails
        onCheckBoxSelected={onAgreedToTerms}
        type="credit"
        selected={hasAgreedToTerms}
      />
      <Button
        text="SUBMIT PAYMENT"
        disabled={loading}
        loading={loading}
        onClick={() => {
          if (loading) {
            return; // prevent double click
          }
          if (!hasAgreedToTerms) {
            return showErrorToast('Please agree to our terms and conditions.');
          }
          return onConfirmation();
        }}
      />
    </Container>
  );
};

export default PackageAndTerms;
